export class PaymentCard {
  id: string;
  brand: string;
  type: string;
  last4: string;
  status: PaymentCardStatus;
  deleted: boolean;
  primary: boolean;
  backup: boolean;
  email?: string;
  actioning?: boolean;
  expiry_date: string; // "02/22" | "04/24"
}

export enum PaymentCardStatus {
  Valid = 'valid',
  Expiring = 'expiring',
  Expired = 'expired',
  Invalid = 'invalid',
  PendingVerification = 'pending_verification',
}
